import { useEffect, useRef, useState } from "react";
import "shaka-player/dist/controls.css";

// Dynamically import Shaka Player (for Next.js or React)
import ShakaPlayer from "shaka-player-react";
const VideoPlayer = ({ src, height }) => {
  const playerRef = useRef(null);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [isMounted, setIsMounted] = useState(false);

  // Effect to track fullscreen mode
  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullScreen(!!document.fullscreenElement);
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () => document.removeEventListener("fullscreenchange", handleFullscreenChange);
  }, []);

  // Ensure Shaka Player loads only after mount (for Next.js)
  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) return <div>Loading video...</div>;

  return (
    <div key={src} className="flex justify-center items-center bg-black object-contain shaka-video w-full h-full">
      <ShakaPlayer
        ref={playerRef}
        className={`w-full h-full object-contain`}
        autoPlay={true}
        src={src}
        isFullScreen={false}
        muted={true}
        volume={0.2}
        objectFit="contain"
      />
    </div>
  );
};

export default VideoPlayer;
